// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"389":"3de81849","465":"3de81849","515":"3de81849","668":"3de81849","799":"3de81849"}[chunkId] + ".chunk.css";
};